// extracted by mini-css-extract-plugin
export default {"booktable":"bookTable_booktable__vdplF","reservation-img":"bookTable_reservation-img__e6AC1"};